import { render, staticRenderFns } from "./cardStudyCard.vue?vue&type=template&id=0b62238a&scoped=true&"
import script from "./cardStudyCard.vue?vue&type=script&lang=js&"
export * from "./cardStudyCard.vue?vue&type=script&lang=js&"
import style0 from "./cardStudyCard.vue?vue&type=style&index=0&id=0b62238a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b62238a",
  null
  
)

export default component.exports